import React from "react";

type IconProps = React.HTMLAttributes<HTMLDivElement>;

export const UsersDownloadCircleIcon = (props: IconProps) => {
  return (
    <div
      style={{
        width: 60,
        height: 60,
        borderRadius: "50%",
        backgroundColor: "#E9EFF4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={28}
        height={28}
        viewBox="0 0 28 28"
        fill="none"
      >
        <path
          d="M19.6 2.8C19.6 1.26 20.86 0 22.4 0C23.94 0 25.2 1.26 25.2 2.8C25.2 4.34 23.94 5.6 22.4 5.6C20.86 5.6 19.6 4.34 19.6 2.8ZM26.292 7.812C25.102 7.294 23.786 7 22.4 7C21.462 7 20.566 7.14 19.712 7.392C20.524 8.162 21 9.24 21 10.402V11.2H28V10.402C28 9.268 27.328 8.26 26.292 7.812ZM5.6 5.6C7.14 5.6 8.4 4.34 8.4 2.8C8.4 1.26 7.14 0 5.6 0C4.06 0 2.8 1.26 2.8 2.8C2.8 4.34 4.06 5.6 5.6 5.6ZM8.288 7.392C7.434 7.14 6.538 7 5.6 7C4.214 7 2.898 7.294 1.708 7.812C0.672 8.26 0 9.268 0 10.402V11.2H7V10.402C7 9.24 7.476 8.162 8.288 7.392ZM11.2 2.8C11.2 1.26 12.46 0 14 0C15.54 0 16.8 1.26 16.8 2.8C16.8 4.34 15.54 5.6 14 5.6C12.46 5.6 11.2 4.34 11.2 2.8ZM19.6 11.2H8.4V10.402C8.4 9.268 9.072 8.26 10.108 7.812C11.298 7.294 12.614 7 14 7C15.386 7 16.702 7.294 17.892 7.812C18.928 8.26 19.6 9.268 19.6 10.402V11.2ZM18.2 19.6C18.2 18.06 19.46 16.8 21 16.8C22.54 16.8 23.8 18.06 23.8 19.6C23.8 21.14 22.54 22.4 21 22.4C19.46 22.4 18.2 21.14 18.2 19.6ZM26.6 28H15.4V27.202C15.4 26.068 16.072 25.06 17.108 24.612C18.298 24.094 19.614 23.8 21 23.8C22.386 23.8 23.702 24.094 24.892 24.612C25.928 25.06 26.6 26.068 26.6 27.202V28ZM4.2 19.6C4.2 18.06 5.46 16.8 7 16.8C8.54 16.8 9.8 18.06 9.8 19.6C9.8 21.14 8.54 22.4 7 22.4C5.46 22.4 4.2 21.14 4.2 19.6ZM12.6 28H1.4V27.202C1.4 26.068 2.072 25.06 3.108 24.612C4.298 24.094 5.614 23.8 7 23.8C8.386 23.8 9.702 24.094 10.892 24.612C11.928 25.06 12.6 26.068 12.6 27.202V28ZM15.05 15.4V12.6H12.95V15.4H9.8L14 19.6L18.2 15.4H15.05Z"
          fill="#22638D"
        />
      </svg>
    </div>
  );
};